import { render, staticRenderFns } from "./SpecialtyFilter.vue?vue&type=template&id=5b9f8312&"
import script from "./SpecialtyFilter.vue?vue&type=script&lang=js&"
export * from "./SpecialtyFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports